document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.testimonial-expanded-testimonials, .testimonial-testimonials');
    
    containers.forEach(function(container) {
        if (!container) return;

        const testimonialComponent = container.querySelector('.testimonial-component');
        const testimonials = container.querySelectorAll('.testimonial-component__content-wrapper');
        const placeholder = container.querySelector('.testimonial-component__content-wrapper-placeholder');
        const totalTestimonials = parseInt(container.dataset.total);
        const prevBtn = container.querySelector('.testimonial-component__nav-prev');
        const nextBtn = container.querySelector('.testimonial-component__nav-next');
        const pagination = container.querySelector('.testimonial-component__nav-pagination');
        const nav = container.querySelector('.testimonial-component__nav');
        
        if (!testimonialComponent || !testimonials.length || !nav || !placeholder) {
            return;
        }
        
        let currentIndex = 0;

        // Create media query
        const desktopMediaQuery = window.matchMedia('(min-width: 1024px)');

        function updatePlaceholderContent(index) {
            // Clone the content from the current testimonial into the placeholder
            const currentTestimonial = testimonials[index];
            if (!currentTestimonial) return;
            
            const imageElement = currentTestimonial.querySelector('.testimonial-component__image img');
            const descriptionElement = currentTestimonial.querySelector('.testimonial-component__content-description');
            const attributionElement = currentTestimonial.querySelector('.testimonial-component__content-attribution');
            
            if (imageElement) {
                const placeholderImage = placeholder.querySelector('.testimonial-component__image img');
                if (placeholderImage) {
                    placeholderImage.src = imageElement.src;
                    placeholderImage.alt = '';
                }
            }
            
            if (descriptionElement) {
                const placeholderDescription = placeholder.querySelector('.testimonial-component__content-description');
                if (placeholderDescription) {
                    placeholderDescription.innerHTML = descriptionElement.innerHTML;
                }
            }
            
            if (attributionElement) {
                const placeholderAttribution = placeholder.querySelector('.testimonial-component__content-attribution');
                if (placeholderAttribution) {
                    placeholderAttribution.innerHTML = attributionElement.innerHTML;
                }
            }
        }

        function calculateMaxHeight() {
            let maxHeight = 0;
            
            // Use the placeholder to measure each testimonial's content
            testimonials.forEach(function(testimonial) {
                // Update placeholder with this testimonial's content
                const imageElement = testimonial.querySelector('.testimonial-component__image img');
                const descriptionElement = testimonial.querySelector('.testimonial-component__content-description');
                const attributionElement = testimonial.querySelector('.testimonial-component__content-attribution');
                
                if (imageElement) {
                    const placeholderImage = placeholder.querySelector('.testimonial-component__image img');
                    if (placeholderImage) {
                        placeholderImage.src = imageElement.src;
                    }
                }
                
                if (descriptionElement) {
                    const placeholderDescription = placeholder.querySelector('.testimonial-component__content-description');
                    if (placeholderDescription) {
                        placeholderDescription.innerHTML = descriptionElement.innerHTML;
                    }
                }
                
                if (attributionElement) {
                    const placeholderAttribution = placeholder.querySelector('.testimonial-component__content-attribution');
                    if (placeholderAttribution) {
                        placeholderAttribution.innerHTML = attributionElement.innerHTML;
                    }
                }
                
                // Measure the placeholder height
                const height = placeholder.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            
            // Restore placeholder to first testimonial
            updatePlaceholderContent(currentIndex);
            
            return maxHeight;
        }

        function calculateDesktopHeight() {
            const maxHeight = calculateMaxHeight();
            
            // On desktop, set fixed height based on tallest testimonial
            testimonialComponent.style.height = (maxHeight + 40) + 'px'; // 20px top + 20px bottom padding
            testimonialComponent.style.minHeight = '';
            nav.style.position = '';
            nav.style.bottom = '';
            nav.style.marginTop = '';
            nav.style.right = '';
        }

        function calculateMobileHeight() {
            const maxHeight = calculateMaxHeight();
            
            // On mobile/tablet, the nav is positioned absolutely inside the container
            // So we just need the max content height + padding
            testimonialComponent.style.height = (maxHeight + 130) + 'px'; // 20px top + 20px bottom padding
            testimonialComponent.style.minHeight = '';
            nav.style.position = '';
            nav.style.bottom = '';
            nav.style.marginTop = '';
            nav.style.right = '';
        }

        function handleViewportChange() {
            if (desktopMediaQuery.matches) {
                calculateDesktopHeight();
            } else {
                calculateMobileHeight();
            }
        }

        function updateTestimonial(newIndex) {
            currentIndex = newIndex;
            
            // Update placeholder content to match new testimonial
            updatePlaceholderContent(newIndex);
            
            testimonials.forEach(function(testimonial) {
                testimonial.classList.remove('active');
            });
            
            setTimeout(function() {
                testimonials[currentIndex].classList.add('active');
            }, 150);

            pagination.textContent = (currentIndex + 1) + '/' + totalTestimonials;
            
            // Enable/disable buttons based on testimonial count
            if (totalTestimonials === 1) {
                prevBtn.disabled = true;
                nextBtn.disabled = true;
            } else {
                // Enable both buttons for infinite loop
                prevBtn.disabled = false;
                nextBtn.disabled = false;
            }
        }

        // Initial setup
        updatePlaceholderContent(0);
        handleViewportChange();

        // Initialize button states for infinite loop
        if (totalTestimonials === 1) {
            prevBtn.disabled = true;
            nextBtn.disabled = true;
        } else {
            prevBtn.disabled = false;
            nextBtn.disabled = false;
        }

        // Listen for viewport changes
        desktopMediaQuery.addEventListener('change', handleViewportChange);

        // Button click handlers with infinite loop
        if (prevBtn) {
            prevBtn.addEventListener('click', function() {
                // Loop to last testimonial if at first
                const newIndex = currentIndex === 0 ? totalTestimonials - 1 : currentIndex - 1;
                updateTestimonial(newIndex);
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function() {
                // Loop to first testimonial if at last
                const newIndex = currentIndex === totalTestimonials - 1 ? 0 : currentIndex + 1;
                updateTestimonial(newIndex);
            });
        }
    });
});

/** Code below before 11/12 update  */

// document.addEventListener('DOMContentLoaded', function() {
//     const containers = document.querySelectorAll('.testimonial-expanded-testimonials, .testimonial-testimonials');
    
//     containers.forEach(function(container) {
//         if (!container) return;

//         const testimonialComponent = container.querySelector('.testimonial-component');
//         const testimonials = container.querySelectorAll('.testimonial-component__content-wrapper');
//         const placeholder = container.querySelector('.testimonial-component__content-wrapper-placeholder');
//         const totalTestimonials = parseInt(container.dataset.total);
//         const prevBtn = container.querySelector('.testimonial-component__nav-prev');
//         const nextBtn = container.querySelector('.testimonial-component__nav-next');
//         const pagination = container.querySelector('.testimonial-component__nav-pagination');
//         const nav = container.querySelector('.testimonial-component__nav');
        
//         if (!testimonialComponent || !testimonials.length || !nav || !placeholder) {
//             return;
//         }
        
//         let currentIndex = 0;

//         // Create media query
//         const desktopMediaQuery = window.matchMedia('(min-width: 1024px)');

//         function updatePlaceholderContent(index) {
//             // Clone the content from the current testimonial into the placeholder
//             const currentTestimonial = testimonials[index];
//             if (!currentTestimonial) return;
            
//             const imageElement = currentTestimonial.querySelector('.testimonial-component__image img');
//             const descriptionElement = currentTestimonial.querySelector('.testimonial-component__content-description');
//             const attributionElement = currentTestimonial.querySelector('.testimonial-component__content-attribution');
            
//             if (imageElement) {
//                 const placeholderImage = placeholder.querySelector('.testimonial-component__image img');
//                 if (placeholderImage) {
//                     placeholderImage.src = imageElement.src;
//                     placeholderImage.alt = '';
//                 }
//             }
            
//             if (descriptionElement) {
//                 const placeholderDescription = placeholder.querySelector('.testimonial-component__content-description');
//                 if (placeholderDescription) {
//                     placeholderDescription.innerHTML = descriptionElement.innerHTML;
//                 }
//             }
            
//             if (attributionElement) {
//                 const placeholderAttribution = placeholder.querySelector('.testimonial-component__content-attribution');
//                 if (placeholderAttribution) {
//                     placeholderAttribution.innerHTML = attributionElement.innerHTML;
//                 }
//             }
//         }

//         function calculateDesktopHeight() {
//             // On desktop, the placeholder maintains the height naturally
//             testimonialComponent.style.minHeight = '430px';
//             testimonialComponent.style.height = ''; // Clear any mobile height
//             nav.style.position = '';
//             nav.style.bottom = '';
//             nav.style.marginTop = '';
//             nav.style.right = '';
//         }

//         function calculateMobileHeight() {
//             // On mobile/tablet, still let the placeholder handle the height naturally
//             testimonialComponent.style.minHeight = '';
//             testimonialComponent.style.height = ''; // Let it be auto
//             nav.style.position = 'absolute';
//             nav.style.bottom = '20px';
//             nav.style.marginTop = '0';
//             nav.style.right = '20px';
//         }

//         function handleViewportChange() {
//             if (desktopMediaQuery.matches) {
//                 calculateDesktopHeight();
//             } else {
//                 calculateMobileHeight();
//             }
//         }

//         function updateTestimonial(newIndex) {
//             currentIndex = newIndex;
            
//             // Update placeholder content to match new testimonial
//             updatePlaceholderContent(newIndex);
            
//             testimonials.forEach(function(testimonial) {
//                 testimonial.classList.remove('active');
//             });
            
//             setTimeout(function() {
//                 testimonials[currentIndex].classList.add('active');
//             }, 150);

//             pagination.textContent = (currentIndex + 1) + '/' + totalTestimonials;
            
//             // Enable/disable buttons based on testimonial count
//             if (totalTestimonials === 1) {
//                 prevBtn.disabled = true;
//                 nextBtn.disabled = true;
//             } else {
//                 // Enable both buttons for infinite loop
//                 prevBtn.disabled = false;
//                 nextBtn.disabled = false;
//             }
//         }

//         // Initial setup
//         updatePlaceholderContent(0);
//         handleViewportChange();

//         // Initialize button states for infinite loop
//         if (totalTestimonials === 1) {
//             prevBtn.disabled = true;
//             nextBtn.disabled = true;
//         } else {
//             prevBtn.disabled = false;
//             nextBtn.disabled = false;
//         }

//         // Listen for viewport changes
//         desktopMediaQuery.addEventListener('change', handleViewportChange);

//         // Button click handlers with infinite loop
//         if (prevBtn) {
//             prevBtn.addEventListener('click', function() {
//                 // Loop to last testimonial if at first
//                 const newIndex = currentIndex === 0 ? totalTestimonials - 1 : currentIndex - 1;
//                 updateTestimonial(newIndex);
//             });
//         }

//         if (nextBtn) {
//             nextBtn.addEventListener('click', function() {
//                 // Loop to first testimonial if at last
//                 const newIndex = currentIndex === totalTestimonials - 1 ? 0 : currentIndex + 1;
//                 updateTestimonial(newIndex);
//             });
//         }
//     });
// });